import { render, staticRenderFns } from "./complaintList.vue?vue&type=template&id=e660b356&scoped=true&"
import script from "./complaintList.vue?vue&type=script&lang=js&"
export * from "./complaintList.vue?vue&type=script&lang=js&"
import style0 from "./complaintList.vue?vue&type=style&index=0&id=e660b356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e660b356",
  null
  
)

component.options.__file = "complaintList.vue"
export default component.exports